import React from 'react';
import styles from './styles.module.scss';

export const FormFieldCell: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <td className={styles.formFieldCell}>{children}</td>
);
